import { Avatar, Card, CardContent, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { AppImages } from "assets/appResources";
import { GlobalClassKeys } from "assets/jss/common-styles";
import CardButtonFilter from "components/Buttons/CardButtonFilter";
import IconButtonCancel from "components/Buttons/IconButtonCancel";
import IconButtonDelete from "components/Buttons/IconButtonDelete";
import CardHeaderColor from "components/MuiExtras/Card/CardHeaderColor";
import MuiTextFieldColor from "components/MuiExtras/CustomInput/MuiTextFieldColor";
import { GridEx } from "components/MuiExtras/Grid/GridEx";
import MuiConfirmation from "components/MuiExtras/MuiConfirmation";
import MuiLink from "components/MuiExtras/MuiLink";
import { WithSnackbar, withSnackbar } from 'components/SnackbarProvider/Snackbar';
import HtmlUtils from "lib/HtmlUtils";
import { UserFollowUserGetDto, UserShortView } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RoutePaths } from "routes/RouteConfig";
import AuthorAutoComplete from "views/User/Components/AuthorAutoComplete";

/////////////////////////////////////////////////////////////////////////////////////

enum FormMode { Search, Add }

interface IProps {
    follow: UserFollowUserGetDto[];
    onChange: (data: UserFollowUserGetDto[]) => void;
    onEndEdit?: () => void;
}

interface IState {
    mode: FormMode;
    searchText: string;
    dialog: any;
    mouseOver: number;
}

type Props = IProps & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class UserEditFollowAuthors extends React.Component<Props, IState> {

    private searchRef: any = null;
    private addRef: any = null;

    ///
    constructor(props: Props) {
        super(props);

        this.state = {
            dialog: null,
            mode: FormMode.Add,
            mouseOver: null,
            searchText: ""
        };
    }

    ///
    private handleFilterSwitch = () => {
        this.setState({
            mode: this.state.mode == FormMode.Add ? FormMode.Search : FormMode.Add,
            searchText: ""
        }, () => {
            if (this.state.mode == FormMode.Search && this.searchRef) this.searchRef.focus();
            else if (this.state.mode == FormMode.Add && this.addRef) this.addRef.focus();
        });
    };

    ///
    private handleExitAddMode = () => {
        if (this.props.onEndEdit) this.props.onEndEdit();
    };

    ///
    private handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ searchText: e.currentTarget.value });
    };

    ///
    private handleFilterClear = () => {
        this.setState({ searchText: "", mode: FormMode.Add }, () => {
            if (this.state.mode == FormMode.Add && this.addRef) this.addRef.focus();
        });
    };

    ///
    private handleAdd(suggestion: UserShortView) {
        var items = this.props.follow;

        if (items.findIndex(p => p.userId == suggestion.id) == -1) {
            items.push({
                userId: suggestion.id,
                name: suggestion.name,
                thumbnailUrl: suggestion.thumbnailUrl,
            });
            this.props.onChange(items);
        }
        else
            this.props.snackbar.showMessage(this.props.t("Common.Literals.AuthorAlreadySelected"), "error");
    }

    ///
    private handleDelete(item: UserFollowUserGetDto) {
        this.setState({
            dialog: <MuiConfirmation
                message={this.props.t("Common.Question.ConfirmationDeleteOfMessage", { name: item.name })}
                onClose={
                    (result) => {
                        if (result) this.props.onChange(this.props.follow.filter(p => p.userId != item.userId));
                        this.setState({ dialog: null });
                    }
                }
            />
        });
    }

    ///
    render() {
        const items = this.state.searchText == ""
            ? this.props.follow
            : this.props.follow.filter(f => f.name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1);

        return (
            <>
                {this.state.dialog}

                <Card>
                    <CardHeaderColor color="primary"
                        title={
                            <>
                                <Grid container={true} justifyContent={"space-between"} >
                                    <Grid item>
                                        <CardButtonFilter
                                            iconSize="large"
                                            color={this.state.mode == FormMode.Add ? "inherit" : "warning"}
                                            title={this.props.t("Views.User.Components.UserEditFollowAuthors.ButtonAddTitle")}
                                            onClick={this.handleFilterSwitch}
                                        />
                                    </Grid>

                                    <GridEx item alignSelf="center">
                                        <span>{this.props.t("Views.User.Components.UserEditFollowAuthors.HeaderTitle")}</span>
                                    </GridEx>

                                    <Grid>
                                    </Grid>
                                </Grid>

                                <Grid container={true} justifyContent={"space-between"} >
                                    <GridEx item xs>
                                        {
                                            this.state.mode == FormMode.Search
                                                ? <MuiTextFieldColor
                                                    fullWidth
                                                    placeholder={this.props.t("Common.Input.Label.SearchFor")}
                                                    inputColor="warning"
                                                    underlineColor="warning"
                                                    value={this.state.searchText}
                                                    onChange={this.handleFilterChange}
                                                    endAdornment={
                                                        this.state.searchText == ""
                                                            ? null
                                                            : <IconButtonCancel color="warning" size="small" onClick={this.handleFilterClear} />
                                                    }
                                                    inputRef={(ref) => this.searchRef = ref}
                                                />
                                                : <AuthorAutoComplete
                                                    placeholder={this.props.t("Common.Input.Placeholder.SelectAddAuthor")}
                                                    escapeOnEmpty={true}
                                                    selectedItems={null}
                                                    inputColor={"inherit"}
                                                    underlineColor={"inherit"}
                                                    onChange={(data) => this.handleAdd(data[0])}
                                                    onEscape={this.handleExitAddMode}
                                                    onBlur={this.handleExitAddMode}
                                                    inputRef={(ref) => this.addRef = ref}
                                                />
                                        }
                                    </GridEx>
                                </Grid>
                            </>
                        }
                    >
                    </CardHeaderColor>

                    <CardContent>
                        {
                            items.length == 0
                                ? <Typography variant="subtitle1">{this.props.t("Views.User.Components.UserEditFollowAuthors.EmptyData")}</Typography>
                                : items.map((item, index) => {

                                    return (
                                        <Grid
                                            key={index}
                                            container
                                            spacing={1}
                                            justifyContent="space-between"
                                            alignItems="center"
                                            wrap="nowrap"
                                            className={this.state.mouseOver == index ? GlobalClassKeys.overElementBackground : null}
                                            onMouseEnter={() => this.setState({ mouseOver: index })}
                                            onMouseLeave={() => this.setState({ mouseOver: null })}
                                        >
                                            <Grid item>
                                                <Avatar src={item.thumbnailUrl || AppImages.NoThumbnailDefined} />
                                            </Grid>
                                            <GridEx item xs zeroMinWidth alignSelf="center">
                                                <MuiLink
                                                    onClick={
                                                        () => {
                                                            HtmlUtils.openUrlInNewWindow(RoutePaths.UserProfileViewer.replace(":id?", item.userId));
                                                        }
                                                    }
                                                >
                                                    <span>{item.name}</span>
                                                </MuiLink>

                                            </GridEx>
                                            <Grid item>
                                                <IconButtonDelete size="small" color="muted" onClick={() => this.handleDelete(item)} />
                                            </Grid>
                                        </Grid>
                                    );
                                })
                        }
                    </CardContent>
                </Card>
            </>
        );
    }
}

export default withSnackbar(withTranslation()(UserEditFollowAuthors));
